import { type Dispatch, useId } from 'react';
import { useTranslation } from 'react-i18next';

import type { CageListItem, LocationAction, LocationListItem } from './apiUserLocations';
import { ListItemComponent } from './ListItemComponent';

import styles from './CreateApiUserModal.module.scss';

interface Props {
    locationsList: LocationListItem[];
    locationListItemsDisabled: boolean;
    cageListItemsDisabled: boolean;
    disableAllButtons: boolean;
    dispatch: Dispatch<LocationAction>;
}

/** The locations, and the cages of the selected ones, an API user can be limited to. */
export function AccessScopeLists(props: Props) {
    const {
        locationsList,
        locationListItemsDisabled,
        cageListItemsDisabled,
        disableAllButtons,
        dispatch,
    } = props;
    const { t } = useTranslation();
    const locationsTitleId = useId();
    const cagesTitleId = useId();

    return (
        <>
            <div className={styles.bodyLocationsListContainer}>
                <div id={locationsTitleId} className={styles.bodyLocationsListTitle}>
                    {t('internal.createApiUser.locations')}
                </div>
                <div
                    role="group"
                    aria-labelledby={locationsTitleId}
                    className={styles.bodyLocationsListItemsContainer}>
                    {locationsList.map((location) => (
                        <ListItemComponent
                            key={location.id}
                            name={location.name}
                            disabled={locationListItemsDisabled || disableAllButtons}
                            selected={location.selected}
                            onToggle={() =>
                                dispatch({
                                    type: 'TOGGLE_LOCATION',
                                    locationId: location.id,
                                })
                            }
                        />
                    ))}
                </div>
            </div>
            <div className={styles.bodyCagesListContainer}>
                <div id={cagesTitleId} className={styles.bodyCagesListTitle}>
                    {t('internal.createApiUser.cages')}
                </div>
                <div
                    role="group"
                    aria-labelledby={cagesTitleId}
                    className={styles.bodyCagesListItemsContainer}>
                    {locationsList
                        .filter((location: LocationListItem) => location.selected)
                        .map((location: LocationListItem) =>
                            location.cages.map((cage: CageListItem) => (
                                <ListItemComponent
                                    key={cage.id}
                                    name={cage.name}
                                    locationName={location.name}
                                    selected={cage.selected}
                                    disabled={cageListItemsDisabled || disableAllButtons}
                                    onToggle={() =>
                                        dispatch({
                                            type: 'TOGGLE_CAGE',
                                            locationId: location.id,
                                            cageId: cage.id,
                                        })
                                    }
                                />
                            ))
                        )}
                </div>
            </div>
        </>
    );
}
